import { NotificationService } from '@/services/notification.service';
import type { WebPushSubscriptionRequestDto } from '@/types/dto/notification.dto';

export function supportsPushNotifications() {
  return (
    typeof window !== 'undefined' &&
    window.isSecureContext &&
    'Notification' in window &&
    'serviceWorker' in navigator &&
    'PushManager' in window
  );
}

export function urlBase64ToUint8Array(value: string) {
  const padding = '='.repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, '+').replace(/_/g, '/');
  const decoded = window.atob(base64);

  return Uint8Array.from(decoded, (character) => character.charCodeAt(0));
}

export function serializePushSubscription(
  subscription: Pick<PushSubscription, 'toJSON'>,
): WebPushSubscriptionRequestDto {
  const serialized = subscription.toJSON();

  if (!serialized.endpoint || !serialized.keys?.p256dh || !serialized.keys.auth) {
    throw new Error('O navegador retornou uma assinatura de push inválida.');
  }

  return {
    endpoint: serialized.endpoint,
    expirationTime: serialized.expirationTime,
    keys: {
      p256dh: serialized.keys.p256dh,
      auth: serialized.keys.auth,
    },
  };
}

export async function getPushRegistration() {
  return navigator.serviceWorker.ready;
}

export async function unsubscribeFromPushNotifications() {
  if (!supportsPushNotifications()) {
    return;
  }

  const registration = await navigator.serviceWorker.getRegistration('/');
  const subscription = await registration?.pushManager.getSubscription();

  if (!subscription) {
    return;
  }

  await NotificationService.unsubscribePush(subscription.endpoint);
  await subscription.unsubscribe();
}
